import { render, staticRenderFns } from "./settingItem.vue?vue&type=template&id=3806ac0b&scoped=true"
import script from "./settingItem.vue?vue&type=script&lang=js"
export * from "./settingItem.vue?vue&type=script&lang=js"
import style0 from "./settingItem.vue?vue&type=style&index=0&id=3806ac0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3806ac0b",
  null
  
)

export default component.exports